
import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import OrderCard from '~/components/OrderCard.vue';
import { UserModule } from '~/store/modules/user';

@Component({
    components: {
        OrderCard,
    },
})
export default class UserOrdersPopup extends Mixins(PopupMixin) {
    get orders() {
        return UserModule.orders;
    }
}
